/**
 * Titulo de la pestana del navegador (ver `formatDocumentTitle`).
 *
 * `null` no toca el titulo: deja que lo ponga otra parte (el marco pone el de
 * la seccion; una pantalla que el marco no conoce, como la de "no existe", el
 * suyo).
 */
import { useEffect } from 'react';
import { readEnvironment } from '../app/environment';
import { formatDocumentTitle } from '../lib/environment';

export function useDocumentTitle(section: string | null): void {
  useEffect(() => {
    if (section !== null) {
      document.title = formatDocumentTitle(section, readEnvironment().environmentLabel);
    }
  }, [section]);
}
